import { modifier } from 'ember-modifier';
import Chart, { type ChartConfiguration } from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Chart as ChartJS } from 'chart.js';
import 'chartjs-adapter-date-fns';

ChartJS.register(annotationPlugin);

export interface DataSet {
  label: string;
  data: { key: string; value: number }[];
  error?: boolean;
}

interface ChartSignature {
  Element: HTMLCanvasElement;
  Args: {
    Named: {
      datasets: DataSet[];
      options: Partial<ChartConfiguration>;
    };
  };
}

export default modifier<ChartSignature>(function chart(element, positional, named) {
  const chart = new Chart(element, {
    ...named.options,
    data: {
      // todo: should we validate that all labels are always the same between datasets? Or just add all of the possible labels of all datasets together?
      labels: named.datasets[0]?.data.map((row) => row.key),
      datasets: named.datasets.map((dataset) => ({
        ...dataset,
        data: dataset.data.map((row) => row.value),
      })),
    },
  } as ChartConfiguration);
  return () => {
    chart.destroy();
  };
});
